export default __webpack_public_path__ + "static/media/mevuelo-blanco.992294e5.svg";